import { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import authService from '../services/auth.service';

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  const userStr = localStorage.getItem('userData');
  let user = null;
  if (userStr) {
    user = JSON.parse(userStr);
  }


  if (user && user.access_token && config.url !== '/api/auth/login') {
    // @ts-ignore
    config.headers.Authorization = `Bearer ${user.access_token}`;
    // console.info(`[request] ${JSON.stringify(config)}`);
  } else {
    // @ts-ignore
    config.headers.Authorization = '';
    authService.logOut();
  }
  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  // console.error(`[request error] ${error}`);
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  // console.log('onResponse', response);
  // console.info(`[response] ${response}`);
  return response;
};

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  // console.error(`[response error] ${error}`);
  const config = error.config;
  if (error?.response?.status === 401 && config.url !== '/api/auth/login') {
    authService.logOut();
    window.location.assign('/login');
    window.location.reload();
  }
  return Promise.reject(error);
};

export function setupInterceptorsTo(
  axiosInstance: AxiosInstance,
): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
